<template>
  <artmisads-modal
    v-model:open="visible"
    title="Join Campaign"
    @cancel="handleCancel"
    @ok="handleSave"
    :maskClosable="false"
    width="600px"
    :footer="null"
  >
    <div>
      <div class="upload-text">
        You have't uploaded your Amazon Associate StorelD, Please
        upload these and then Join Campaign
      </div>
      <div class="bottom-btn">
        <artmisads-button type="primary" @click="goUpload">
          Upload now
        </artmisads-button>
      </div>
    </div>
  </artmisads-modal>
</template>
<script setup>
import { ref ,defineExpose,defineProps} from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const props = defineProps({
  marketplace: {
    type: String,
    default: ''
  }
})
const visible = ref(false)
const handleCancel = () => {
  visible.value = false
}
const handleSave = () => {
  visible.value = false
}
const goUpload = () => {
  router.push(`/publisher/campaigns/upload?marketplace=${props.marketplace}`)
}
defineExpose({
  open: () => {
    visible.value = true
  }
})
</script>
<style lang="less" scoped>
.bottom-btn{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
</style>